
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "payments-ui-app",
  currentProjectVersion: "static-1.28928",
  depVersions: {
  "payments-ui-app": "static-1.28928",
  "apollo-dlb": "static-3.98",
  "bend-plugin-arboretum": "static-1.2092",
  "client-types": "static-1.524",
  "crm_data": "static-4.93361",
  "data-fetching-client": "static-1.10174",
  "emoji-mart": "static-3.10",
  "enviro": "static-4.529",
  "foundations-components": "static-1.8851",
  "foundations-components-legacy": "static-1.1876",
  "head-dlb": "static-1.5344",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6129",
  "hs-test-utils": "static-1.8581",
  "hub-http": "static-1.6744",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.12028",
  "I18n": "static-7.1724",
  "jasmine-runner": "static-1.6997",
  "quartz": "static-1.7759",
  "raven": "static-3.6435",
  "react-dlb": "static-1.97",
  "react-stripe-js": "static-1.124",
  "react-utils": "static-2.5718",
  "reselect": "static-3.20",
  "stripe-js": "static-1.123",
  "ui-components-test-utils": "static-1.6165",
  "UIComponents": "static-3.8974",
  "usage-tracker-public": "static-1.7692",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38172",
  "cssUtils": "static-1.1162",
  "customer-data-objects": "static-1.8253",
  "FireAlarmUi": "static-1.4927",
  "foundations-assets": "static-1.5428",
  "foundations-theming": "static-1.5040",
  "graphql": "static-1.96",
  "hs-browser-apis": "static-1.18",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12335",
  "icons": "static-2.716",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3415",
  "payments-checkout-lib": "static-1.851",
  "property-translator": "static-1.5915",
  "quartz-config": "static-1.1537",
  "quartz-core": "static-1.6978",
  "quartz-i18n": "static-1.1434",
  "quartz-routing": "static-1.1189",
  "quartz-tracking": "static-1.1138",
  "react": "static-7.206",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17278",
  "react-select-plus": "static-1.121",
  "react-virtualized": "static-2.115",
  "redux": "static-4.81",
  "redux-thunk": "static-2.88",
  "redux-toolkit": "static-1.85",
  "ReduxMessenger": "static-2.10911",
  "rpc-client-utils": "static-1.5205",
  "sanitize-text": "static-1.8696",
  "SharedI18nStrings": "static-1.191",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.521",
  "superstore": "static-1.5294",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11686",
  "ui-images": "static-2.1296",
  "usage-tracker-core": "static-1.7731",
  "hs-promise-rejection-tracking": "static-1.6102",
  "PortalIdParser": "static-2.459",
  "raven-hubspot": "static-1.6742",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.4036",
  "quartz-webpack": "static-1.3983",
  "bend-plugin-quartz-routing": "static-1.837",
  "bender-build-tools": "static-1.3648",
  "crm_universal": "static-1.22813",
  "customer-data-email": "static-1.18737",
  "customer-data-ui-utilities": "static-1.10372",
  "dispatcher": "static-1.151",
  "frontend-preferences-client": "static-1.8462",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8297",
  "quick-fetch": "static-1.4267",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5120",
  "floating-ui": "static-1.71",
  "foundations-theming-specialty": "static-1.2756",
  "framer-motion": "static-1.87",
  "hs-story-utils": "static-1.9963",
  "react-aria": "static-1.80",
  "react-create-root-preference": "static-1.122",
  "tanstack-table": "static-1.69",
  "trellis-assets": "static-1.3262",
  "ui-fonts": "static-1.1290",
  "HeadJS": "static-2.837",
  "hs-test-utils-bend-plugin": "static-1.3692",
  "msw": "static-1.106",
  "msw-config": "static-1.43",
  "testing-library": "static-1.168",
  "hs-locale-management": "static-1.442",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.238",
  "moment-timezone": "static-5.99",
  "jasmine": "static-4.4844",
  "foundations-components-test-utils": "static-1.6334",
  "ui-addon-draggable": "static-3.5291",
  "commerce-billing-lib": "static-1.20621",
  "commerce-shared-components-lib": "static-1.19696",
  "commerce-tools-ui-lib": "static-1.11435",
  "crm-message-bus": "static-1.44259",
  "customer-data-objects-ui-components": "static-1.13575",
  "customer-data-properties": "static-1.53252",
  "growth-payments-core": "static-1.26631",
  "ui-addon-iframeable": "static-1.9619",
  "usage-tracker": "static-1.7881",
  "usage-tracker-container": "static-1.7871",
  "sassPrefix": "static-1.426",
  "inbound-db-properties-service-client": "static-1.4190",
  "foundations-theming-base": "static-1.4025",
  "bend-plugin-foundations-theming": "static-1.3523",
  "stylex": "static-1.49",
  "opentelemetry-fe-types": "static-1.339",
  "hub-http-janus": "static-1.920",
  "hubspotter-http": "static-1.5013",
  "mobile-manifest-mixins": "static-1.619",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.714",
  "quartz-auth": "static-1.1434",
  "quartz-head": "static-1.1424",
  "quartz-test": "static-1.1434",
  "trellis-components": "static-1.3281",
  "usage-tracker-session-replay": "static-1.5567",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.241",
  "web-vitals": "static-1.22",
  "immer": "static-1.107",
  "bend-plugin-chirp-manifest": "static-1.615",
  "chirp-fetch": "static-1.2439",
  "autolinker": "static-3.11",
  "sanitize": "static-1.5007",
  "FormUrlGenerator": "static-2.5253",
  "sequences-lib": "static-1.8873",
  "apollo-link-hub-http": "static-2.5128",
  "FileManagerCore": "static-1.40437",
  "FileManagerLib": "static-1.40578",
  "hubspot-apollo-client": "static-1.5415",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.797",
  "timezone-utils": "static-2.5765",
  "ui-gdpr-components": "static-1.10659",
  "react-dnd-compat": "static-1.5149",
  "stylex-utils": "static-1.191",
  "trellis-theming": "static-1.1582",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.86",
  "avatar-components": "static-1.3027",
  "crm-command-handler-types": "static-1.197",
  "hs-resources": "static-1.735",
  "onboarding-scopes": "static-1.6991",
  "pulse": "static-1.1208",
  "upgrade-components-lib": "static-1.797",
  "utility-belt": "static-1.3074",
  "zustand": "static-1.93",
  "batch-promise": "static-1.2089",
  "customer-data-associations": "static-1.7883",
  "customer-data-property-utils": "static-1.8598",
  "customer-data-tracking": "static-1.7410",
  "framework-data-table": "static-2.12947",
  "object-builder-ui-client": "static-1.50222",
  "payments-enrollment-embed-lib": "static-1.24404",
  "stripe-embedded-components": "static-1.8336",
  "ui-addon-opt": "static-4.8974",
  "ai-components-ui-library": "static-1.10132",
  "customer-data-rte": "static-1.34004",
  "cv-backend-services": "static-1.1622",
  "file-manager-components": "static-1.24938",
  "growth-onboarding-confetti": "static-1.3595",
  "growth-onboarding-empty-states": "static-1.6630",
  "hubspot-prosemirror": "static-1.19405",
  "InboxConnectUtils": "static-4.15960",
  "payment-link-components": "static-1.24589",
  "payments-post-enroll-local-storage-lib": "static-1.5639",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.83",
  "quotes-client-types": "static-1.39294",
  "react-colorpicker": "static-2.10748",
  "ui-addon-upgrades": "static-9.18610",
  "ui-addon-video-player": "static-1.9161",
  "user-context": "static-1.5597",
  "atom": "static-1.5612",
  "reference-resolvers": "static-1.8725",
  "calling-global-api": "static-1.66522",
  "calling-internal-common": "static-1.31862",
  "calling-lifecycle-internal": "static-1.67904",
  "calling-lifecycle-messages": "static-1.60196",
  "commerce-products-lib": "static-1.11098",
  "conditional-properties-service-client": "static-1.4150",
  "crm-index-visualization-core": "static-1.4851",
  "crm-links": "static-1.6866",
  "crm-pipelines-api-client-types": "static-1.4484",
  "customer-data-properties-shared-msw-handlers": "static-1.10334",
  "data-agent-utils": "static-1.1066",
  "data-token-picker": "static-1.17226",
  "external-options-client-types": "static-1.4478",
  "formula-editor": "static-1.15085",
  "google-libphonenumber": "static-1.53",
  "inbound-db-meta-service-client": "static-1.3810",
  "inbounddb-objects-service-types": "static-1.4554",
  "meetings-icalendar-utils-lib": "static-1.1174",
  "multi-currency-client-types": "static-1.4049",
  "pipeline-validation-client-types": "static-1.4322",
  "property-value-citations": "static-1.3866",
  "react-tinymce": "static-1.56376",
  "reference-resolvers-lite": "static-1.8652",
  "rich-text-lib": "static-1.20647",
  "smart-data-capture-core": "static-1.616",
  "tiered-pricing": "static-1.2390",
  "tinymce-config": "static-2.55502",
  "tinymce-plugins": "static-1.58616",
  "tinymce-themes": "static-1.57472",
  "topics-actions-lib": "static-1.732",
  "trellis-ext-i18n": "static-1.1482",
  "trial-components-library": "static-1.14484",
  "ui-addon-emoji-picker": "static-1.10403",
  "ui-addon-form-validation": "static-1.11353",
  "laboratory-lib": "static-3.7687",
  "seat-types-lib": "static-1.1175",
  "magpie-lib": "static-1.5962",
  "navigation-messaging": "static-1.8650",
  "ts-schema": "static-1.4433",
  "opentelemetry-web": "static-1.26",
  "hub-http-shared-msw-handlers": "static-1.11007",
  "hubspotter-http-shared-msw-handlers": "static-1.11005",
  "base-ui": "static-1.32",
  "react-day-picker": "static-1.19",
  "tanstack-virtual": "static-1.46",
  "amplitude-session-replay-browser": "static-1.80",
  "sequences-client-types-lib": "static-1.8730",
  "audio-components": "static-1.6653",
  "breeze-artifacts-sdk": "static-1.1219",
  "ContentUtils": "static-1.69622",
  "copilot-toolkit": "static-1.12269",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30151",
  "FileManagerImages": "static-1.38089",
  "html-to-image": "static-1.68",
  "immerable": "static-1.4683",
  "ui-universal-auth": "static-1.9864",
  "urlinator": "static-1.5056",
  "video-components": "static-1.14556",
  "video-data-lib": "static-1.36212",
  "video-embed": "static-1.37046",
  "hubspot-apollo-cache": "static-1.874",
  "trellis-migration-context": "static-1.117",
  "event-emitter": "static-1.1499",
  "fdsr-migration-layer": "static-1.553",
  "framework-builder-read-service-client": "static-1.4374",
  "bend-plugin-pulse": "static-1.711",
  "fast-json-patch": "static-1.77",
  "merchandise-lib": "static-1.291",
  "purchase-motions-components": "static-1.6722",
  "customer-data-reference-ui-components": "static-1.13715",
  "reporting-data": "static-1.69644",
  "tasks-actions-lib": "static-1.564",
  "growth-onboarding-feedback-components": "static-1.7124",
  "growth-onboarding-reliability": "static-1.5622",
  "marketplace-ui-apps-core": "static-1.19691",
  "onboarding-tours": "static-1.17484",
  "stripe-connect-js": "static-1.86",
  "chatspot-core": "static-1.24280",
  "content-assistance-lib": "static-1.8506",
  "draft-content-plugins": "static-1.29256",
  "draft-convert": "static-2.88",
  "draft-extend": "static-3.91",
  "draft-js": "static-5.93",
  "draft-plugins": "static-2.22452",
  "breeze-engine-lib": "static-1.2392",
  "poll-commands": "static-1.4015",
  "video-components-external": "static-1.12554",
  "trellis-story-utils": "static-1.5035",
  "ui-addon-react-router-dom": "static-1.10067",
  "content-media-capture": "static-1.5890",
  "knowledge-content-types": "static-1.8767",
  "ui-business-units-lib": "static-1.9635",
  "ui-shepherd-react": "static-3.10826",
  "hub-http-contrib": "static-1.3569",
  "ui-addon-sales-email": "static-1.5746",
  "commerce-tours-lib": "static-1.6952",
  "getting-started-shared-tasks": "static-1.19664",
  "sales-checkout-service-client": "static-1.4061",
  "getting-started-shared-tasks-store": "static-1.18782",
  "onboarding-tours-utils": "static-1.1551",
  "calling-error-reporting": "static-1.31869",
  "shared-worker-versioning": "static-1.11579",
  "calling-usage-tracker": "static-1.7080",
  "conversations-skeleton-state": "static-1.7652",
  "voice-sms-access-library": "static-1.2614",
  "commerce-permissions": "static-1.1322",
  "products-iframe-lib": "static-1.9060",
  "products-ui-components-shared-msw-handlers": "static-1.11389",
  "crm-index-associations-lib": "static-1.6989",
  "sales-views-client-types": "static-1.4797",
  "location-customization-utils-lib": "static-1.10561",
  "data-agent-kit": "static-1.1053",
  "enrichment-settings-lib": "static-1.413",
  "fsm": "static-1.4300",
  "markdown-it": "static-1.6",
  "policy-lib": "static-1.7343",
  "bark-lib": "static-1.17073",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.109",
  "crm-properties-common-lib": "static-1.6436",
  "react-codemirror": "static-1.11181",
  "tinymce": "static-5.11",
  "interframe": "static-3.5284",
  "tinymce-data": "static-1.41587",
  "layout-dnd-components": "static-1.13321",
  "layout-dnd-utils": "static-1.12296",
  "ui-brand-identity-lib": "static-1.17101",
  "NamespacedHubStyle": "static-2.9407",
  "embedded-academy-lib": "static-1.16209",
  "hubs-service-types": "static-1.1805",
  "navigation-components": "static-1.19323",
  "nest": "static-1.777",
  "nudge-client-utils": "static-1.3512",
  "purchase-motions-api": "static-1.6725",
  "signup-constants": "static-1.20116",
  "idb-keyval": "static-1.58",
  "magpie-types": "static-1.5422",
  "reactive-lib": "static-1.1261",
  "simple-logging-lib": "static-1.3586",
  "nav-meta": "static-1.30960",
  "breeze-engine-core": "static-1.1670",
  "cms-field-types": "static-1.5352",
  "content-icons-ui": "static-1.2523",
  "integrations-lib": "static-1.17564",
  "underscore": "static-1.8",
  "custom-vendor-connection-lib": "static-1.428",
  "unified-auth-core-lib": "static-1.1660",
  "social-insights-client-types": "static-1.23047",
  "outpost": "static-1.4665",
  "persist-promise": "static-1.4246",
  "signup-ui-url-generator": "static-2.8574",
  "reporting-client-types": "static-1.2901",
  "developer-experience-shared-components": "static-1.11084",
  "immutable-less": "static-1.5187",
  "marketplace-ui-client-types": "static-1.18566",
  "marketplace-ui-common": "static-1.21159",
  "ui-addon-integrations-directory-panel": "static-2.8488",
  "ui-extensibility-client-types": "static-1.4457",
  "growth-data-modal": "static-1.6220",
  "growth-onboarding-next-action-utils": "static-1.3102",
  "onboarding-tours-client": "static-1.5699",
  "ui-shepherd-tracker": "static-1.8207",
  "ui-coaching-tips": "static-1.29642",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1370",
  "highlight.js": "static-1.93",
  "content-media-composition-data-lib": "static-1.13694",
  "content-media-compositions": "static-2.17701",
  "media-bridge-lib": "static-1.19732",
  "fix-webm-duration": "static-1.38",
  "notification-sounds": "static-1.4968",
  "calling-orchestration-schema": "static-1.37391",
  "crm-record-cards-service-types": "static-1.3895",
  "highcharts": "static-8.118",
  "storybook-react": "static-1.47",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16774",
  "browser-eslint": "static-2.57",
  "ContentData": "static-1.69697",
  "layout-data-lib": "static-1.10621",
  "academy-common-lib": "static-1.15670",
  "nudge-custom-function-registry": "static-1.3269",
  "nudge-renderer-utils": "static-1.3588",
  "whisper-core-api": "static-1.7742",
  "flux-actions": "static-1.384",
  "integrations-error-boundary-lib": "static-1.14979",
  "integrations-tracking-lib": "static-1.6167",
  "redux-observable": "static-1.82",
  "rxjs": "static-5.10",
  "apps-service-types": "static-1.4147",
  "oauth-service-types": "static-1.4675",
  "ai-settings-ui-library": "static-1.8688",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1813",
  "onboarding-data-sync-lib": "static-1.2924",
  "growth-onboarding-next-action-components": "static-1.3130",
  "user-context-client": "static-1.5046",
  "js-cookie": "static-1.18",
  "advanced-menus-core": "static-1.15912",
  "advanced-menus-lib": "static-1.12641",
  "ExportDialog": "static-6.10913",
  "ui-memberships-settings-lib": "static-1.35332",
  "academy-service-client": "static-1.4232",
  "croppie": "static-2.10",
  "final-form": "static-1.86",
  "SafeStorage": "static-1.4934",
  "trellis-ecosystem": "static-1.7940",
  "universal-page-editor-lib": "static-1.3559",
  "settings-ui-lib": "static-1.13071",
  "simple-data-table": "static-1.3943",
  "meetings-connect-utils-lib": "static-1.8158",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15911",
  "simple-menus-lib": "static-1.17428",
  "crm-record-cards-client": "static-1.233",
  "framework-data-schema-resolvers": "static-1.7432",
  "framework-data-schema-quick-fetch": "static-1.7337"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28928",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.2092",
  "client-types": "/client-types/static-1.524",
  "crm_data": "/crm_data/static-4.93361",
  "data-fetching-client": "/data-fetching-client/static-1.10174",
  "emoji-mart": "/emoji-mart/static-3.10",
  "enviro": "/enviro/static-4.529",
  "foundations-components": "/foundations-components/static-1.8851",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1876",
  "head-dlb": "/head-dlb/static-1.5344",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6129",
  "hs-test-utils": "/hs-test-utils/static-1.8581",
  "hub-http": "/hub-http/static-1.6744",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.12028",
  "I18n": "/I18n/static-7.1724",
  "jasmine-runner": "/jasmine-runner/static-1.6997",
  "quartz": "/quartz/static-1.7759",
  "raven": "/raven/static-3.6435",
  "react-dlb": "/react-dlb/static-1.97",
  "react-stripe-js": "/react-stripe-js/static-1.124",
  "react-utils": "/react-utils/static-2.5718",
  "reselect": "/reselect/static-3.20",
  "stripe-js": "/stripe-js/static-1.123",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6165",
  "UIComponents": "/UIComponents/static-3.8974",
  "usage-tracker-public": "/usage-tracker-public/static-1.7692",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38172",
  "cssUtils": "/cssUtils/static-1.1162",
  "customer-data-objects": "/customer-data-objects/static-1.8253",
  "FireAlarmUi": "/FireAlarmUi/static-1.4927",
  "foundations-assets": "/foundations-assets/static-1.5428",
  "foundations-theming": "/foundations-theming/static-1.5040",
  "graphql": "/graphql/static-1.96",
  "hs-browser-apis": "/hs-browser-apis/static-1.18",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12335",
  "icons": "/icons/static-2.716",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3415",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.851",
  "property-translator": "/property-translator/static-1.5915",
  "quartz-config": "/quartz-config/static-1.1537",
  "quartz-core": "/quartz-core/static-1.6978",
  "quartz-i18n": "/quartz-i18n/static-1.1434",
  "quartz-routing": "/quartz-routing/static-1.1189",
  "quartz-tracking": "/quartz-tracking/static-1.1138",
  "react": "/react/static-7.206",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17278",
  "react-select-plus": "/react-select-plus/static-1.121",
  "react-virtualized": "/react-virtualized/static-2.115",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.88",
  "redux-toolkit": "/redux-toolkit/static-1.85",
  "ReduxMessenger": "/ReduxMessenger/static-2.10911",
  "rpc-client-utils": "/rpc-client-utils/static-1.5205",
  "sanitize-text": "/sanitize-text/static-1.8696",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.191",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.521",
  "superstore": "/superstore/static-1.5294",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11686",
  "ui-images": "/ui-images/static-2.1296",
  "usage-tracker-core": "/usage-tracker-core/static-1.7731",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6102",
  "PortalIdParser": "/PortalIdParser/static-2.459",
  "raven-hubspot": "/raven-hubspot/static-1.6742",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.4036",
  "quartz-webpack": "/quartz-webpack/static-1.3983",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.837",
  "bender-build-tools": "/bender-build-tools/static-1.3648",
  "crm_universal": "/crm_universal/static-1.22813",
  "customer-data-email": "/customer-data-email/static-1.18737",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10372",
  "dispatcher": "/dispatcher/static-1.151",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8462",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8297",
  "quick-fetch": "/quick-fetch/static-1.4267",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5120",
  "floating-ui": "/floating-ui/static-1.71",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2756",
  "framer-motion": "/framer-motion/static-1.87",
  "hs-story-utils": "/hs-story-utils/static-1.9963",
  "react-aria": "/react-aria/static-1.80",
  "react-create-root-preference": "/react-create-root-preference/static-1.122",
  "tanstack-table": "/tanstack-table/static-1.69",
  "trellis-assets": "/trellis-assets/static-1.3262",
  "ui-fonts": "/ui-fonts/static-1.1290",
  "HeadJS": "/HeadJS/static-2.837",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3692",
  "msw": "/msw/static-1.106",
  "msw-config": "/msw-config/static-1.43",
  "testing-library": "/testing-library/static-1.168",
  "hs-locale-management": "/hs-locale-management/static-1.442",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.238",
  "moment-timezone": "/moment-timezone/static-5.99",
  "jasmine": "/jasmine/static-4.4844",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6334",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5291",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20621",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19696",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11435",
  "crm-message-bus": "/crm-message-bus/static-1.44259",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13575",
  "customer-data-properties": "/customer-data-properties/static-1.53252",
  "growth-payments-core": "/growth-payments-core/static-1.26631",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9619",
  "usage-tracker": "/usage-tracker/static-1.7881",
  "usage-tracker-container": "/usage-tracker-container/static-1.7871",
  "sassPrefix": "/sassPrefix/static-1.426",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4190",
  "foundations-theming-base": "/foundations-theming-base/static-1.4025",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3523",
  "stylex": "/stylex/static-1.49",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.339",
  "hub-http-janus": "/hub-http-janus/static-1.920",
  "hubspotter-http": "/hubspotter-http/static-1.5013",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.619",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.714",
  "quartz-auth": "/quartz-auth/static-1.1434",
  "quartz-head": "/quartz-head/static-1.1424",
  "quartz-test": "/quartz-test/static-1.1434",
  "trellis-components": "/trellis-components/static-1.3281",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5567",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.241",
  "web-vitals": "/web-vitals/static-1.22",
  "immer": "/immer/static-1.107",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.615",
  "chirp-fetch": "/chirp-fetch/static-1.2439",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.5007",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5253",
  "sequences-lib": "/sequences-lib/static-1.8873",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5128",
  "FileManagerCore": "/FileManagerCore/static-1.40437",
  "FileManagerLib": "/FileManagerLib/static-1.40578",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5415",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.797",
  "timezone-utils": "/timezone-utils/static-2.5765",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10659",
  "react-dnd-compat": "/react-dnd-compat/static-1.5149",
  "stylex-utils": "/stylex-utils/static-1.191",
  "trellis-theming": "/trellis-theming/static-1.1582",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.86",
  "avatar-components": "/avatar-components/static-1.3027",
  "crm-command-handler-types": "/crm-command-handler-types/static-1.197",
  "hs-resources": "/hs-resources/static-1.735",
  "onboarding-scopes": "/onboarding-scopes/static-1.6991",
  "pulse": "/pulse/static-1.1208",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.797",
  "utility-belt": "/utility-belt/static-1.3074",
  "zustand": "/zustand/static-1.93",
  "batch-promise": "/batch-promise/static-1.2089",
  "customer-data-associations": "/customer-data-associations/static-1.7883",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8598",
  "customer-data-tracking": "/customer-data-tracking/static-1.7410",
  "framework-data-table": "/framework-data-table/static-2.12947",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50222",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24404",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8336",
  "ui-addon-opt": "/ui-addon-opt/static-4.8974",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10132",
  "customer-data-rte": "/customer-data-rte/static-1.34004",
  "cv-backend-services": "/cv-backend-services/static-1.1622",
  "file-manager-components": "/file-manager-components/static-1.24938",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3595",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6630",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19405",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15960",
  "payment-link-components": "/payment-link-components/static-1.24589",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5639",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.83",
  "quotes-client-types": "/quotes-client-types/static-1.39294",
  "react-colorpicker": "/react-colorpicker/static-2.10748",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18610",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9161",
  "user-context": "/user-context/static-1.5597",
  "atom": "/atom/static-1.5612",
  "reference-resolvers": "/reference-resolvers/static-1.8725",
  "calling-global-api": "/calling-global-api/static-1.66522",
  "calling-internal-common": "/calling-internal-common/static-1.31862",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67904",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.60196",
  "commerce-products-lib": "/commerce-products-lib/static-1.11098",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4150",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4851",
  "crm-links": "/crm-links/static-1.6866",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4484",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10334",
  "data-agent-utils": "/data-agent-utils/static-1.1066",
  "data-token-picker": "/data-token-picker/static-1.17226",
  "external-options-client-types": "/external-options-client-types/static-1.4478",
  "formula-editor": "/formula-editor/static-1.15085",
  "google-libphonenumber": "/google-libphonenumber/static-1.53",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3810",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4554",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1174",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4049",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4322",
  "property-value-citations": "/property-value-citations/static-1.3866",
  "react-tinymce": "/react-tinymce/static-1.56376",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8652",
  "rich-text-lib": "/rich-text-lib/static-1.20647",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.616",
  "tiered-pricing": "/tiered-pricing/static-1.2390",
  "tinymce-config": "/tinymce-config/static-2.55502",
  "tinymce-plugins": "/tinymce-plugins/static-1.58616",
  "tinymce-themes": "/tinymce-themes/static-1.57472",
  "topics-actions-lib": "/topics-actions-lib/static-1.732",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1482",
  "trial-components-library": "/trial-components-library/static-1.14484",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10403",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11353",
  "laboratory-lib": "/laboratory-lib/static-3.7687",
  "seat-types-lib": "/seat-types-lib/static-1.1175",
  "magpie-lib": "/magpie-lib/static-1.5962",
  "navigation-messaging": "/navigation-messaging/static-1.8650",
  "ts-schema": "/ts-schema/static-1.4433",
  "opentelemetry-web": "/opentelemetry-web/static-1.26",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.11007",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.11005",
  "base-ui": "/base-ui/static-1.32",
  "react-day-picker": "/react-day-picker/static-1.19",
  "tanstack-virtual": "/tanstack-virtual/static-1.46",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.80",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8730",
  "audio-components": "/audio-components/static-1.6653",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1219",
  "ContentUtils": "/ContentUtils/static-1.69622",
  "copilot-toolkit": "/copilot-toolkit/static-1.12269",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30151",
  "FileManagerImages": "/FileManagerImages/static-1.38089",
  "html-to-image": "/html-to-image/static-1.68",
  "immerable": "/immerable/static-1.4683",
  "ui-universal-auth": "/ui-universal-auth/static-1.9864",
  "urlinator": "/urlinator/static-1.5056",
  "video-components": "/video-components/static-1.14556",
  "video-data-lib": "/video-data-lib/static-1.36212",
  "video-embed": "/video-embed/static-1.37046",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.874",
  "trellis-migration-context": "/trellis-migration-context/static-1.117",
  "event-emitter": "/event-emitter/static-1.1499",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.553",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4374",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.711",
  "fast-json-patch": "/fast-json-patch/static-1.77",
  "merchandise-lib": "/merchandise-lib/static-1.291",
  "purchase-motions-components": "/purchase-motions-components/static-1.6722",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13715",
  "reporting-data": "/reporting-data/static-1.69644",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.564",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7124",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5622",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19691",
  "onboarding-tours": "/onboarding-tours/static-1.17484",
  "stripe-connect-js": "/stripe-connect-js/static-1.86",
  "chatspot-core": "/chatspot-core/static-1.24280",
  "content-assistance-lib": "/content-assistance-lib/static-1.8506",
  "draft-content-plugins": "/draft-content-plugins/static-1.29256",
  "draft-convert": "/draft-convert/static-2.88",
  "draft-extend": "/draft-extend/static-3.91",
  "draft-js": "/draft-js/static-5.93",
  "draft-plugins": "/draft-plugins/static-2.22452",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2392",
  "poll-commands": "/poll-commands/static-1.4015",
  "video-components-external": "/video-components-external/static-1.12554",
  "trellis-story-utils": "/trellis-story-utils/static-1.5035",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10067",
  "content-media-capture": "/content-media-capture/static-1.5890",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9635",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10826",
  "hub-http-contrib": "/hub-http-contrib/static-1.3569",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5746",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6952",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19664",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4061",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18782",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1551",
  "calling-error-reporting": "/calling-error-reporting/static-1.31869",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11579",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7080",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7652",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2614",
  "commerce-permissions": "/commerce-permissions/static-1.1322",
  "products-iframe-lib": "/products-iframe-lib/static-1.9060",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11389",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6989",
  "sales-views-client-types": "/sales-views-client-types/static-1.4797",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10561",
  "data-agent-kit": "/data-agent-kit/static-1.1053",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.413",
  "fsm": "/fsm/static-1.4300",
  "markdown-it": "/markdown-it/static-1.6",
  "policy-lib": "/policy-lib/static-1.7343",
  "bark-lib": "/bark-lib/static-1.17073",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.109",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6436",
  "react-codemirror": "/react-codemirror/static-1.11181",
  "tinymce": "/tinymce/static-5.11",
  "interframe": "/interframe/static-3.5284",
  "tinymce-data": "/tinymce-data/static-1.41587",
  "layout-dnd-components": "/layout-dnd-components/static-1.13321",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12296",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17101",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9407",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16209",
  "hubs-service-types": "/hubs-service-types/static-1.1805",
  "navigation-components": "/navigation-components/static-1.19323",
  "nest": "/nest/static-1.777",
  "nudge-client-utils": "/nudge-client-utils/static-1.3512",
  "purchase-motions-api": "/purchase-motions-api/static-1.6725",
  "signup-constants": "/signup-constants/static-1.20116",
  "idb-keyval": "/idb-keyval/static-1.58",
  "magpie-types": "/magpie-types/static-1.5422",
  "reactive-lib": "/reactive-lib/static-1.1261",
  "simple-logging-lib": "/simple-logging-lib/static-1.3586",
  "nav-meta": "/nav-meta/static-1.30960",
  "breeze-engine-core": "/breeze-engine-core/static-1.1670",
  "cms-field-types": "/cms-field-types/static-1.5352",
  "content-icons-ui": "/content-icons-ui/static-1.2523",
  "integrations-lib": "/integrations-lib/static-1.17564",
  "underscore": "/underscore/static-1.8",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.428",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1660",
  "social-insights-client-types": "/social-insights-client-types/static-1.23047",
  "outpost": "/outpost/static-1.4665",
  "persist-promise": "/persist-promise/static-1.4246",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8574",
  "reporting-client-types": "/reporting-client-types/static-1.2901",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11084",
  "immutable-less": "/immutable-less/static-1.5187",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18566",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21159",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8488",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4457",
  "growth-data-modal": "/growth-data-modal/static-1.6220",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3102",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5699",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8207",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29642",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1370",
  "highlight.js": "/highlight.js/static-1.93",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13694",
  "content-media-compositions": "/content-media-compositions/static-2.17701",
  "media-bridge-lib": "/media-bridge-lib/static-1.19732",
  "fix-webm-duration": "/fix-webm-duration/static-1.38",
  "notification-sounds": "/notification-sounds/static-1.4968",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37391",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3895",
  "highcharts": "/highcharts/static-8.118",
  "storybook-react": "/storybook-react/static-1.47",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16774",
  "browser-eslint": "/browser-eslint/static-2.57",
  "ContentData": "/ContentData/static-1.69697",
  "layout-data-lib": "/layout-data-lib/static-1.10621",
  "academy-common-lib": "/academy-common-lib/static-1.15670",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3269",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3588",
  "whisper-core-api": "/whisper-core-api/static-1.7742",
  "flux-actions": "/flux-actions/static-1.384",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14979",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6167",
  "redux-observable": "/redux-observable/static-1.82",
  "rxjs": "/rxjs/static-5.10",
  "apps-service-types": "/apps-service-types/static-1.4147",
  "oauth-service-types": "/oauth-service-types/static-1.4675",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8688",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1813",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2924",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3130",
  "user-context-client": "/user-context-client/static-1.5046",
  "js-cookie": "/js-cookie/static-1.18",
  "advanced-menus-core": "/advanced-menus-core/static-1.15912",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12641",
  "ExportDialog": "/ExportDialog/static-6.10913",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35332",
  "academy-service-client": "/academy-service-client/static-1.4232",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.86",
  "SafeStorage": "/SafeStorage/static-1.4934",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7940",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3559",
  "settings-ui-lib": "/settings-ui-lib/static-1.13071",
  "simple-data-table": "/simple-data-table/static-1.3943",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8158",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15911",
  "simple-menus-lib": "/simple-menus-lib/static-1.17428",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.233",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7432",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7337"
}
};
